import { config } from "../config/index.js";

/**
 * Get an uri for the apps page.
 *
 * @returns Apps page uri.
 */
export function getAppsPageUri(): string {
    if (config.app.url && config.baseApi !== config.app.url) {
        return `${config.app.url.replace(/\/$/, "")}/`;
    }
    return "/apps";
}
